import { render, staticRenderFns } from "./ComplaintSectorFilter.vue?vue&type=template&id=1474f0a6&"
import script from "./ComplaintSectorFilter.vue?vue&type=script&lang=js&"
export * from "./ComplaintSectorFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports